import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "search", "department", "status"]

  connect() {
    console.log("Teacher Profiles Filters Controller connected!")
  }

  filter() {
    // Déclencher automatiquement la soumission du formulaire lors des changements
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.formTarget.requestSubmit()
    }, 300)
  }
}
